import { GameTextUtil } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/GameTextUtil";
import { GameScatterWinProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameScatterWinProperties";
import { Point } from "pixi.js";
export class ScatterWinPortraitProperties extends GameScatterWinProperties {
    constructor() {
        super();
        this.position.set(512, 973);
        const text = [this.winProperties, this.bigWinProperties, this.epicWinProperties, this.megaWinProperties].map(x => x.text);
        text.forEach(x => {
            x.size = new Point(800, 600);
            x.fontProperties.setLineHeight(200);
        });
        GameTextUtil.centerProperties(...text);
    }
}
//# sourceMappingURL=ScatterWinPortraitProperties.js.map